/**
 * Determines whether a string is null, undefined, or empty.
 * @param value The string to check.
 * @returns true if the value is null, undefined, or an empty string; otherwise, false.
 */
export default function isNullOrEmpty(value: string | null | undefined): value is null | undefined | "";
/**
 * Determines whether an array is null, undefined, or empty.
 * @param value The array to check.
 * @returns true if the value is null, undefined, or has no items; otherwise, false.
 * When false, the value is narrowed to a non-null array.
 */
export default function isNullOrEmpty<T>(value: readonly T[] | null | undefined): value is null | undefined;
export default function isNullOrEmpty(value: string | readonly unknown[] | null | undefined): boolean {
	return value == null || value.length === 0;
}
